import initialStateLoader from 'redux/initialState';
import AuthService from 'services/AuthService';

import { clearHuggg } from 'redux/modules/huggg';
import { clearHugggs } from 'redux/modules/hugggs';

const auth = new AuthService();
const defaultState = initialStateLoader().auth.status;

/* Action Types
========================================================================== */
export const SET_LOADING = 'auth/status/SET_LOADING';
export const SET_ERROR = 'auth/status/SET_ERROR';
export const SET_LOGGED_IN = 'auth/status/SET_LOGGED_IN';

/* Reducer | Default Export
========================================================================== */
const reducer = (state = defaultState, { type, payload }) => {
  switch (type) {
  case SET_LOADING:
    return {
      ...state,
      loading: payload.loading
    };

  case SET_ERROR:
    return {
      ...state,
      error: payload.error
    };

  case SET_LOGGED_IN:
    return {
      ...state,
      loggedIn: payload.loggedIn,
      userId: payload.userId
    };

  default:
    return state;
  }
};

export default reducer;

/* Action Creators
========================================================================== */
export const logout = () => dispatch => {
  auth.logout();
  dispatch(setLoggedIn(false));
  dispatch(clearHuggg());
  dispatch(clearHugggs());
};

export const setError = error => dispatch =>
  dispatch({ type: SET_ERROR, payload: { error } });

export const setLoading = loading => dispatch =>
  dispatch({ type: SET_LOADING, payload: { loading } });

export const setLoggedIn = loggedIn => dispatch =>
  dispatch({
    type: SET_LOGGED_IN,
    payload: { loggedIn, userId: auth.getUserId() }
  });

/* Selectors
========================================================================== */
export const isAuthed = state => state.auth.status.loggedIn;
export const isLoading = state => state.auth.status.loading;
export const getError = state => state.auth.status.error;
export const getUserId = state => state.auth.status.userId;
